import { render, staticRenderFns } from "./GroceriesPage.vue?vue&type=template&id=5789f07c&scoped=true&"
import script from "./GroceriesPage.vue?vue&type=script&lang=js&"
export * from "./GroceriesPage.vue?vue&type=script&lang=js&"
import style0 from "./GroceriesPage.vue?vue&type=style&index=0&id=5789f07c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5789f07c",
  null
  
)

export default component.exports